import * as Yup from 'yup'
import { time } from 'utils/form'
import { parseMomentFromLocalDateAndLocalTimeFields } from 'utils/date'
import moment from 'moment-timezone'

function validateTimeIsAfterLastStatusChange (formRef, minNewStatusDateTime) {
  const time = formRef.current.values.time
  const date = formRef.current.values.date
  if (time && date) {
    const parsedDate = parseMomentFromLocalDateAndLocalTimeFields(date, time)
    const minimumDateTime = moment(minNewStatusDateTime).local()
    return parsedDate.isSameOrAfter(minimumDateTime, 'minute')
  }
  return true
}

function validateTimeIsBeforeNow (formRef) {
  const time = formRef.current.values.time
  const date = formRef.current.values.date
  if (time && date) {
    const parsedDate = parseMomentFromLocalDateAndLocalTimeFields(date, time)
    return parsedDate.isSameOrBefore(moment())
  }
  return true
}

export const createUpdateStatusChangeSchema = (formRef, minNewStatusDateTime) => Yup.object().shape({
  time: time().required()
    .test('time',
      ' ', () => {
        return validateTimeIsBeforeNow(formRef)
      }).test('time',
      ' ', () => {
        return minNewStatusDateTime ? validateTimeIsAfterLastStatusChange(formRef, minNewStatusDateTime) : true
      }),
  date: Yup.string()
    .test('date',
      'form.validation.dateFromFuture', () => {
        return validateTimeIsBeforeNow(formRef)
      }).test('date',
      'form.validation.dateBeforeLastStatusChange', () => {
        return minNewStatusDateTime ? validateTimeIsAfterLastStatusChange(formRef, minNewStatusDateTime) : true
      }),
  cancellationCause: Yup.string().nullable(),
  rejectionCause: Yup.string().nullable(),
  timeZone: Yup.string()
})